import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-reporting }}",{ moduleName: "embercom/components/reporting/custom/report/bridge-chart-edit.hbs" })